var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUpFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3787 6.70153L19.7961 16.2966C19.8487 16.3648 19.8788 16.4439 19.8834 16.5257C19.8879 16.6075 19.8666 16.6888 19.8218 16.761C19.777 16.8332 19.7103 16.8935 19.6289 16.9356C19.5475 16.9777 19.4543 17 19.3594 17L4.52459 17C4.42965 17 4.33651 16.9777 4.25507 16.9356C4.17363 16.8935 4.10696 16.8332 4.06215 16.761C4.01733 16.6888 3.99606 16.6075 4.0006 16.5257C4.00514 16.4439 4.03531 16.3648 4.08791 16.2966L11.5053 6.70153C11.5532 6.63953 11.6182 6.5887 11.6943 6.55355C11.7705 6.51839 11.8556 6.5 11.942 6.5C12.0284 6.5 12.1135 6.51839 12.1896 6.55355C12.2658 6.5887 12.3307 6.63953 12.3787 6.70153Z",
    fill: "#CCCFD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUpFill);
export default __webpack_public_path__ + "static/media/icon-up-fill.fe61c437a4ec0124ad7e03ce6cab64e9.svg";
export { ForwardRef as ReactComponent };